import { State } from '@/stores/reports/state';
import { Actions } from '@/stores/reports/actions';
import { Getters } from '@/stores/reports/getters';
import { Mutations } from '@/stores/reports/mutations';
import { Module } from 'vuex';

export class ReportsStore implements Module<State, any> {
    public namespaced: boolean = true;
    public state: State = new State();
    public actions: Actions = new Actions();
    public getters: Getters = new Getters();
    public mutations: Mutations = new Mutations();
}
